import { FC, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import AppLayout from '../../components/layout/app-layout/app-layout';
import BackButton from '../../components/shared/BackButton/BackButton';
import styles from './page-supplier-evaluations.module.scss';

type Props = {
  path: string[];
  backTo: string;
  children?: ReactNode;
};

const EvaluationsLayout: FC<Props> = ({ path, backTo, children }) => {
  const history = useHistory();

  return (
    <AppLayout title={<BackButton path={path} onClick={() => history.push(backTo)} />}>
      <div className={styles.page}>{children}</div>
    </AppLayout>
  );
};

export default EvaluationsLayout;
